import { render } from "./SkeletonTerm.vue?vue&type=template&id=6697ff1e&scoped=true"
const script = {}

import "./SkeletonTerm.vue?vue&type=style&index=0&id=6697ff1e&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6697ff1e"]])

export default __exports__